import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const elementId = hash.replace("#", "");
      const element = document.getElementById(elementId);
      if (element) {
        const headerHeight = 72;
        const rect = element.getBoundingClientRect();
        const elementPosition = rect.top + window.scrollY - headerHeight;
        window.scrollTo({
          top: elementPosition,
          behavior: "smooth"
        });
      } else {
        // Poll for element in case of async page loads
        let attempts = 0;
        const interval = setInterval(() => {
          const el = document.getElementById(elementId);
          attempts++;
          if (el) {
            const headerHeight = 72;
            const rect = el.getBoundingClientRect();
            const elementPosition = rect.top + window.scrollY - headerHeight;
            window.scrollTo({
              top: elementPosition,
              behavior: "smooth"
            });
            clearInterval(interval);
          } else if (attempts > 20) {
            clearInterval(interval);
          }
        }, 100);
        return () => clearInterval(interval);
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;